import { jsx as _jsx } from "react/jsx-runtime";
import * as Sentry from '@sentry/react';
import React, { useEffect, useMemo } from 'react';
import BrokenIcon from './BrokenIcon/BrokenIcon';
import PlaceholderEntity from './PlaceholderEntity';
const ErrorBoundary = ({ forceError = false, scale, rotation, position = [0, 0, 0], renderOrder, children, onPointerUp, onPointerDown, onError }) => {
    useEffect(() => {
        if (!forceError)
            return;
        const err = new Error('error loading component');
        onError?.(err);
        Sentry.startSpan({ name: "entity-load-error" }, () => {
            Sentry.captureException(err);
        });
    }, [forceError, onError]);
    const memo = useMemo(() => ({
        scale,
        rotation,
        position,
        fillRgba: [227, 227, 227, 1],
        borderRgba: [181, 181, 181, 1],
    }), [scale, rotation, position]);
    const errorPlaceholder = (_jsx(PlaceholderEntity, { rotation: memo.rotation, fillRgba: memo.fillRgba, scale: memo.scale, position: memo.position, renderOrder: renderOrder, onPointerDown: onPointerDown || undefined, onPointerUp: onPointerUp || undefined, children: _jsx(BrokenIcon, { scale: memo.scale, renderOrder: renderOrder + 2 }) }));
    return (_jsx(Sentry.ErrorBoundary, { fallback: errorPlaceholder, onError: (e, compStack, eventId) => {
            onError?.(e, compStack || '', eventId);
        }, children: forceError ? errorPlaceholder : children }));
};
export default ErrorBoundary;
